import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { Role } from 'api/users'

import { selectSessionStatus } from 'slices/sessionSlice'

export const TENANT_ADMIN_ID = 0

const useAuthority = (workspaceId?: number) => {
  const { user } = useSelector(selectSessionStatus, shallowEqual)

  const role = React.useMemo(() => user.userHasTenants[0]?.role, [user])

  const isReadOnlyWorkspace = React.useMemo(() => {
    if (!user) {
      return true
    }
    if (role === Role.Admin) {
      return false
    }

    if (workspaceId === undefined) {
      return true
    }

    return !user.userHasTenants[0].managedWorkspaces.some(
      workspace => workspace.isManagement && workspace.id === workspaceId
    )
  }, [user, role, workspaceId])

  const isTenantAdmin = React.useMemo(() => role === Role.TenantAdmin, [role])

  const isAdmin = React.useMemo(() => role === Role.Admin, [role])

  const isProcessAdmin = React.useMemo(() => role === Role.ProcessAdmin, [role])

  return { isReadOnlyWorkspace, isTenantAdmin, isAdmin, isProcessAdmin }
}

export default useAuthority
